import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function RoomService(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M12 2a1 1 0 011-1h2.5a1 1 0 110 2H13a1 1 0 01-1-1zm-5.994 8.887l.015-.239A7.734 7.734 0 017.045 7.49C8.113 5.688 10.198 4 14.035 4s5.909 1.688 6.96 3.498a7.659 7.659 0 011.005 3.5V11a1 1 0 01-1 1H6.988A1 1 0 016 10.997l.006-.11zM19.855 10a5.579 5.579 0 00-.59-1.498C18.574 7.312 17.163 6 14.035 6c-3.129 0-4.56 1.313-5.269 2.51A5.655 5.655 0 008.16 10h11.695zM7.236 13a2 2 0 00-.894.211l-3.79 1.895A1 1 0 002 16v4a2 2 0 002 2h5.917a2 2 0 00.329-.027l5.782-.964c.181-.03.358-.085.524-.164l3.971-1.873a2.595 2.595 0 00-2.038-4.768l-3.518 1.352A3 3 0 0012 13H7.236zM12 15a1 1 0 011 1h-3a1 1 0 100 2h4a1 1 0 00.359-.067l4.844-1.863a.595.595 0 01.467 1.093L15.7 19.036 9.917 20H4v-3.382L7.236 15H12z",
    clipRule: "evenodd"
  }));
}

export default RoomService;